export default {
  levelPrivilege: '等级权益',
  levelPrivilegeDesc:
    '等级权益是基于用户在社区的活跃情况而获取的积分所决定，达到相应积分的即可升级。等级从低到高依次为注册用户、L1、L2。等级越高，享受的权益越多。',
  userGetPointsWayTitle: '用户获取积分升级的方式',
  above: '以上',
  registeredUser: '注册用户',
  points: '积分',
  level: '级别',
  privilege: '权益',
  userLevelDivision: '用户等级划分',
  userUpgradeDowngrade: '用户升降级',
  userUpgradeDowngradeDesc:
    '系统会实时更新用户的累计积分，达到晋级条件的，直接升入对应等级，用户晋级不冲减积分。用户的级别永久有效，但会有相关处罚措施，违返平台规则的将扣减200以上不等的积分，当积分下降到低于当前等级要求时即会降级处理。',
  levelPrivilegeTips: '* 平台会根据业务需求对等级权益进行增减，相关调整后不会额外通知。'
}
